module.exports = __webpack_public_path__ + "static/media/svg.6ba2fb4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/svg.svg
// module id = 1685
// module chunks = 17